module.exports = __webpack_public_path__ + "img/A.a2f62dcd.jpg";